export const EQUIFAX_LOGO = '/img/icons/equifax.png';
export const EQUIFAX_LOGO_ALT = 'Logo de Equifax';

export const FALP_LOGO = '/img/icons/falp.png';
export const FALP_LOGO_ALT = 'Logo de Falp';
